module.exports = __webpack_public_path__ + "img/wxpay.2b7feec3.png";